import { useState } from "react";
import {CaretUpFilled, CaretDownFilled} from  "@ant-design/icons";


function FAQQuestion({ question, answer }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="faq-question">
      <div className={isOpen ? "faq-question-header opened" : "faq-question-header"} onClick={() => setIsOpen(!isOpen)}>
        <h3>{question}</h3>
        {isOpen ? (
          <CaretUpFilled className="faq-toggle-icon" />
        ) : (
          <CaretDownFilled className="faq-toggle-icon" />
        )}
      </div>
      <div className="faq-question-answer">
        {isOpen && <p>{answer}</p>}
      </div>
    </div>
  );
}


const FAQdata = [
  {
    question: "Do I need to be a financial expert to use PreNumbers?",
    answer: "Not at all! PreNumbers is designed to be intuitive and user-friendly, even if you don't have a strong financial background. We provide educational resources and clear visualizations to help you understand your business finances easily."
  },
  {
    question: "How secure is my data with PreNumbers?",
    answer: "We take data security seriously and implement robust measures to protect your information. All data is encrypted in transit and at rest, and we comply with industry standards to ensure your privacy."
  },
  {
    question: "What kind of businesses can use PreNumbers?",
    answer: "PreNumbers is designed for small to medium-sized businesses across various industries. Whether you're in retail, services, or manufacturing, our platform can help you manage your finances effectively."
  },
  {
    question: "Can I cancel my subscription at any time?",
    answer: "Yes, you can cancel your subscription at any time. We offer flexible plans to suit your needs, and you won't be charged for the next billing cycle if you cancel before the end of your current period."
  },
  {
    question: "Is there a free trial available?",
    answer: "Yes, we offer a 14-day free trial for new users to explore our features without any commitment."
  }
];


function FAQSection() {
  return (
    <div className="faq-section">
      <h2>Frequently Asked Questions</h2>
      <div className="faq-questions-container">
        {FAQdata.map((item, index) => (
          <FAQQuestion question={item.question} answer={item.answer} key={index} />
        ))}
      </div>
    </div>
  );
}

export default FAQSection;